import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { loginUser, getStudentDetails } from "../../lib/AuthApi";
import PasswordInput from "./components/PasswordInput";
import { useAuth } from "../../context/AuthProvider";
import Logo from "../../components/common/Logo";
import { getSubscriptions } from "../../lib/Subscription"
import { Bell, User, Settings, LogOut, ShoppingCart, Tv, CircleHelp, PlayIcon } from "lucide-react";

const LoginPage = () => {
    const navigate = useNavigate();
    const { setUserData } = useAuth();

    const [form, setForm] = useState({
        username: "",
        password: "",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (field, value) => {
        setForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const inputClass =
        "w-full h-[58px] sm:h-[50px] bg-[#f7f7f7] border border-[#bfb8b0] rounded-[3px] px-5 text-[16px] sm:text-[18px] outline-none text-[#1d1d1d] placeholder:text-[#b7afa8] focus:border-[#6c54ab]";
    //===============Handle Login ===================
    // const handleLogin = async (e) => {
    //     e.preventDefault();

    //     if (!form.username.trim() || !form.password.trim()) {
    //         return setError("Username and password required");
    //     }

    //     try {
    //         setLoading(true);
    //         setError("");

    //         const res = await loginUser({
    //             username: form.username,
    //             password: form.password,
    //         });

    //         console.log("Login Response:", res);

    //         // response validation
    //         if (!res?.data?.isSuccess) {
    //             setError(res?.data?.displayMessage || "Login failed");
    //             return;
    //         }

    //         // actual user data
    //         const userData = {
    //             token: res.data.token || res.data.result.token,
    //             userID: res.data.userID || res.data.result.loginId,
    //             uuid: res.data.uuid || res.data.result.uuid,
    //             sessionId: res.data.result.sessionId,
    //             role: res.data.roleName || res.data.result.roleName,
    //             subscription: "Active"
    //         };

    //         console.log("Final User Data:", userData);

    //         // save to context + localStorage
    //         setUserData(userData);

    //         //navigate("/subscription");

    //         navigate("/live-classes");
    //         //navigate("/subscription");
    //     } catch (err) {
    //         console.log(err);

    //         setError(
    //             err?.response?.data?.message ||
    //             err?.message ||
    //             "Invalid credentials"
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    //     const handleLogin = async (e) => {

    //     e.preventDefault();

    //     if (!form.username.trim() || !form.password.trim()) {
    //         return setError("Username and password required");
    //     }

    //     try {

    //         setLoading(true);
    //         setError("");

    //         // ================= LOGIN API =================

    //         const res = await loginUser({
    //             username: form.username,
    //             password: form.password,
    //         });

    //         console.log("Login Response:", res);

    //         // ================= VALIDATION =================

    //        // response validation
    // if (!res?.data?.isSuccess) {
    //     setError(res?.message || "Login failed");
    //     return;
    // }

    // const result = res?.data?.result;

    // const userData = {
    //     token: result?.token,
    //     userID: result?.userID,
    //     uuid: result?.uuid,
    //     sessionId: result?.sessionId,
    //     role: result?.roleName,
    //     subscription: "Active"
    // };

    // console.log("Final User Data:", userData);

    // // save
    // setUserData(userData);

    // localStorage.setItem("user", JSON.stringify(userData));

    // navigate("/live-classes");

    //         // ================= STUDENT DETAILS API =================

    //         const studentRes = await getStudentDetails({
    //             ID: -1,
    //             UserID: form.username,
    //         });

    //         console.log("Student Details:", studentRes);

    //         const studentData = studentRes?.[0] || {};

    //         // ================= FINAL MERGED DATA =================

    //         const finalUserData = {
    //             ...userData,
    //             ...studentData,
    //         };

    //         console.log("Final User Data:", finalUserData);

    //         // ================= SAVE USER =================

    //         setUserData(finalUserData);

    //         // ================= NAVIGATE =================

    //         navigate("/live-classes");

    //     } catch (err) {

    //         console.log(err);

    //         setError(
    //             err?.response?.data?.message ||
    //             err?.message ||
    //             "Invalid credentials"
    //         );

    //     } finally {

    //         setLoading(false);

    //     }
    // };

    // const handleLogin = async (e) => {

    //     e.preventDefault();

    //     if (!form.username.trim() || !form.password.trim()) {

    //         setError("Username and password required");
    //         return;

    //     }

    //     try {

    //         setLoading(true);
    //         setError("");

    //         // ================= LOGIN API =================

    //         const res = await loginUser({
    //             username: form.username,
    //             password: form.password,
    //         });

    //         console.log("Login Response:", res);

    //         // ================= VALIDATION =================

    //         if (!res?.data?.isSuccess) {

    //             setError(res?.message || "Login failed");
    //             return;

    //         }

    //         // ================= LOGIN RESULT =================

    //         const result = res?.data?.result;

    //         // ================= BASIC USER DATA =================

    //         const basicUser = {
    //             token: result?.token,
    //             userID: result?.userID,
    //             uuid: result?.uuid,
    //             sessionId: result?.sessionId,
    //             role: result?.roleName,
    //             subscription: "Active",
    //         };

    //         console.log("Basic User:", basicUser);

    //         // ================= SAVE BASIC USER =================

    //         localStorage.setItem(
    //             "user",
    //             JSON.stringify(basicUser)
    //         );

    //         // ================= STUDENT DETAILS API =================

    //         const studentRes = await getStudentDetails();

    //         console.log("Student Details:", studentRes);

    //         // axios response
    //         const studentData = studentRes?.data?.[0] || {};

    //         // ================= FINAL MERGED USER =================

    //         const finalUserData = {
    //             ...basicUser,
    //             ...studentData,
    //         };

    //         console.log("Final User Data:", finalUserData);

    //         // ================= SAVE FINAL USER =================

    //         localStorage.setItem(
    //             "user",
    //             JSON.stringify(finalUserData)
    //         );

    //         setUserData(finalUserData);

    //         // ================= NAVIGATE =================

    //         navigate("/live-classes");
    //        //  navigate("/subscription");

    //     } catch (err) {

    //         console.log(err);

    //         setError(
    //             err?.response?.data?.message ||
    //             err?.message ||
    //             "Invalid credentials"
    //         );

    //     } finally {

    //         setLoading(false);

    //     }
    // };
    const handleLogin = async (e) => {

        e.preventDefault();

        if (!form.username.trim() || !form.password.trim()) {

            setError("Username and password required");
            return;
        }

        try {

            setLoading(true);
            setError("");

            // ================= LOGIN API =================

            const res = await loginUser({
                username: form.username,
                password: form.password,
            });

            console.log("Login Response:", res);

            // ================= VALIDATION =================

            if (!res?.data?.isSuccess) {

                setError(res?.message || "Login failed");
                return;
            }

            // ================= LOGIN RESULT =================

            const result = res?.data?.result;

            // ================= BASIC USER =================

            const basicUser = {
                token: result?.token,
                userID: result?.userID,
                uuid: result?.uuid,
                sessionId: result?.sessionId,
                role: result?.roleName,
            };

            // ================= SAVE BASIC USER FIRST =================
            // IMPORTANT

            localStorage.setItem(
                "user",
                JSON.stringify(basicUser)
            );

            // optional
            setUserData(basicUser);


            // ================= STUDENT DETAILS =================

            const studentRes = await getStudentDetails();
            console.log("Student Details:", studentRes);

            const studentData = studentRes?.data?.[0] || {};

            // ================= FINAL USER =================

            let finalUserData = {
                ...basicUser,
                ...studentData,
            };

            // ================= ROLE =================

            const role =
                finalUserData?.role
                    ?.toLowerCase();


            // =====================================================
            // STUDENT
            // =====================================================

            if (role === "student") {

                // ================= CHECK SUBSCRIPTION =================

                const subRes = await getSubscriptions(
                    finalUserData.uuid
                );

                console.log(
                    "Subscription Response:",
                    subRes
                );

                // ================= ADD SUBSCRIPTION =================

                finalUserData = {
                    ...finalUserData,
                    hasSubscription:
                        subRes?.success || false,
                    subscriptionData:
                        subRes?.data || null,
                };

                // ================= SAVE USER =================

                localStorage.setItem(
                    "user",
                    JSON.stringify(finalUserData)
                );

                setUserData(finalUserData);

                // ================= REDIRECT =================

                if (subRes?.success) {

                    navigate("/live-classes");

                } else {

                    navigate("/subscription");

                }

            }


            // =====================================================
            // TEACHER / ADMIN
            // =====================================================

            else if (
                role === "teacher" ||
                role === "admin"
            ) {

                finalUserData = {
                    ...finalUserData,
                    hasSubscription: true,
                };

                localStorage.setItem(
                    "user",
                    JSON.stringify(finalUserData)
                );

                setUserData(finalUserData);

                navigate("/live-classes");
            }


            // =====================================================
            // INVALID ROLE
            // =====================================================

            else {

                setError("Invalid user role");

            }


            // // ================= CHECK SUBSCRIPTION =================

            // const subRes = await getSubscriptions(
            //     finalUserData.uuid
            // );

            // console.log("Subscription Response:", subRes);

            // // ================= SUBSCRIPTION FLAG =================

            // finalUserData = {
            //     ...finalUserData,
            //     hasSubscription: subRes?.success || false,
            //     subscriptionData: subRes?.data || null,
            // };

            // // ================= SAVE USER =================

            // localStorage.setItem(
            //     "user",
            //     JSON.stringify(finalUserData)
            // );

            // setUserData(finalUserData);

            // // ================= REDIRECT =================

            // if (subRes?.success) {

            //     navigate("/live-classes");

            // } else {

            //     navigate("/subscription");

            // }

        } catch (err) {

            console.log(err);

            setError(
                err?.response?.data?.message ||
                err?.message ||
                "Invalid credentials"
            );

        } finally {

            setLoading(false);

        }
    };

    return (
        <>
            <title>Login | InstaED</title>

            <main className="h-screen overflow-hidden">
                <div className="relative h-full w-full max-w-[1600px] mx-auto px-4 sm:px-6 md:px-10 lg:px-14 py-5 flex flex-col">
                    {/* LOGO */}
                    <header className="absolute top-5 left-4 sm:left-6 md:left-10 lg:left-14 z-20 h-5">
                        <Logo />
                    </header>

                    <section className="flex-1 flex flex-col lg:flex-row items-center justify-around gap-10 lg:gap-16 pt-[90px] pb-[70px]">
                        {/* LEFT */}
                        <div className="hidden md:flex flex-col gap-5 w-full max-w-[320px] lg:ml-4">
                            <div className="bg-[#6c54ab] text-white rounded-[4px] p-5 shadow-sm">
                                <h2 className="text-[18px] font-semibold mb-3">Class 6-10</h2>
                                <p className="text-[16px] leading-8 font-medium">4 pm - 6 pm | 3 days / week</p>
                                <p className="text-[16px] font-medium">Math & Science</p>
                            </div>

                            <div className="bg-[#6c54ab] text-white rounded-[4px] p-5 shadow-sm">
                                <h2 className="text-[18px] font-semibold mb-3">Class 11-12</h2>
                                <p className="text-[16px] leading-8 font-medium">4 pm - 6 pm | 6 days / week</p>
                                <p className="text-[16px] font-medium">Math/ Bio, Che, Phy</p>
                            </div>


                            <div className="text-[18px] sm:text-[20px] lg:text-[20px] font-semibold text-[#161616] mb-7">



                                <Link to="/demo-session" className="flex items-center gap-3 hover:opacity-70 transition">
                                    <PlayIcon size={45} className="icon text-primary" />
                                    View Sample class</Link>



                            </div>
                        </div>

                        {/* RIGHT */}
                        <div className="w-full max-w-[500px] flex flex-col justify-center">
                            <h1 className="text-[34px] sm:text-[38px] lg:text-[42px] font-semibold text-[#161616] mb-7">Login</h1>

                            <form onSubmit={handleLogin} className="space-y-4">
                                <input
                                    type="text"
                                    name="username"
                                    // autoComplete="username"
                                    placeholder="Enter user name"
                                    value={form.username}
                                    onChange={(e) => handleChange("username", e.target.value)}
                                    className={inputClass}
                                //className="w-full h-[58px] sm:h-[50px] bg-[#f7f7f7] border border-[#bfb8b0] rounded-[3px] px-5 text-[16px] sm:text-[18px] outline-none text-[#1d1d1d] placeholder:text-[#b7afa8] focus:border-[#6c54ab]"
                                />

                                <PasswordInput
                                    value={form.password}
                                    onChange={(e) => handleChange("password", e.target.value)}
                                    placeholder="Enter password"
                                    className={inputClass}
                                // className="w-full h-[58px] sm:h-[50px] bg-[#f7f7f7] border border-[#bfb8b0] rounded-[3px] px-5 text-[16px] sm:text-[18px] outline-none text-[#1d1d1d] placeholder:text-[#b7afa8] focus:border-[#6c54ab]"
                                />

                                {/* OPTIONS */}
                                <div className="grid grid-cols-2 gap-y-2 pt-3 text-[14px] sm:text-[16px] font-semibold text-[#171717]">
                                    <label className="flex items-center gap-3 cursor-pointer">
                                        <input type="checkbox" defaultChecked className="w-4 h-4 accent-black" />
                                        <span>Stay signed in</span>
                                    </label>

                                    <Link to="/forget-password" className="text-left hover:opacity-70 transition">Forgot password?</Link>
                                    <Link to="/login-with-otp" className="text-left hover:opacity-70 transition">Login via OTP</Link>
                                    <Link to="/signup" className="hover:opacity-70 transition">New user? sign up</Link>
                                </div>

                                {/* BUTTON */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    aria-label="Login"
                                    className="w-full h-[56px] mt-2 bg-[#151515] text-white rounded-[3px] text-[17px] sm:text-[18px] font-semibold hover:opacity-90 transition disabled:opacity-60"
                                >
                                    {loading ? "Logging in..." : "Login"}
                                </button>

                                <div className="min-h-[24px] pt-1">
                                    {/* ERROR MESSAGE FIXED HEIGHT */}
                                    <div className="min-h-[24px] pt-1">
                                        {error && (
                                            <p className="text-red-500 text-sm leading-5 animate-fadeIn">
                                                {error}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </form>

                            {/* LINKS */}
                            <nav className="mt-8 space-y-0 text-[15px] sm:text-[17px] font-semibold text-[#171717] ">
                                <button className="flex items-center gap-3 hover:opacity-70 transition  ">
                                    <CircleHelp size={30} className="text-primary " />
                                    <a href="/howtouse">How it works</a></button>
                                <button className="flex items-center gap-3 hover:opacity-70 transition mt-20">
                                    <ShoppingCart size={30} className="text-primary" />
                                    <a href="/subscription">Buy/ renew subscription</a>
                                </button>

                                <button className="flex items-center gap-3 hover:opacity-70 transition">
                                    <Tv size={30} className="text-primary" />
                                    <a href="/">Display the screen on your smart TV</a>
                                </button>
                            </nav>
                        </div>
                    </section>

                    {/* FOOTER */}
                    <footer className="absolute bottom-4 left-0 w-full text-center text-[12px] sm:text-[14px] text-[#4c4c4c]">
                        <span>2026</span>
                        <span className="mx-3">|</span>
                        <button className="hover:opacity-70 transition">
                            <a href="/terms-condition">Terms of Use</a></button>
                        <span className="mx-3">|</span>
                        <button className="hover:opacity-70 transition">
                            <a href="/policy">Privacy Policy</a>
                        </button>
                    </footer>
                </div>
            </main>
        </>
    );
};

export default LoginPage;